import React from "react";

type Props = {
  className?: string;
  size?: number;
  color?: string;
};

const TriangleAlertIcon = ({ className = "", size = 62, color = "#991B1B" }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M31 3.5C46.1878 3.5 58.5 15.8122 58.5 31C58.5 46.1878 46.1878 58.5 31 58.5C15.8122 58.5 3.5 46.1878 3.5 31C3.5 15.8122 15.8122 3.5 31 3.5Z"
        fill="#FEE2E2"
      />
      <path
        d="M31 3.5C46.1878 3.5 58.5 15.8122 58.5 31C58.5 46.1878 46.1878 58.5 31 58.5C15.8122 58.5 3.5 46.1878 3.5 31C3.5 15.8122 15.8122 3.5 31 3.5Z"
        stroke="#FEF2F2"
        strokeWidth="7"
      />
      <path
        d="M41.5406 37.5L32.874 22.3333C32.685 21.9999 32.411 21.7225 32.0798 21.5296C31.7487 21.3366 31.3722 21.235 30.989 21.235C30.6057 21.235 30.2293 21.3366 29.8981 21.5296C29.567 21.7225 29.2929 21.9999 29.104 22.3333L20.4373 37.5C20.2463 37.8308 20.1461 38.2062 20.147 38.5882C20.1478 38.9702 20.2496 39.3452 20.4421 39.6752C20.6346 40.0051 20.9109 40.2783 21.243 40.4671C21.5751 40.6558 21.9512 40.7534 22.3331 40.75H39.6665C40.0466 40.7496 40.42 40.6492 40.749 40.4589C41.0781 40.2686 41.3513 39.995 41.5412 39.6657C41.7311 39.3364 41.831 38.9629 41.8309 38.5828C41.8308 38.2026 41.7307 37.8292 41.5406 37.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M31 27.75V32.0833" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M31 36.4167H31.0108" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default TriangleAlertIcon;
